// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,<svg width=%27121%27 height=%2726%27 viewBox=%270 0 121 26%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27><path fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M108.596 18.8277V6.78682H111.422V11.6023L116.802 6.78682H120.628L114.208 12.3797L120.858 18.8277H116.898L111.422 13.3513V18.8277H108.596Z%27 fill=%27white%27/><path fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M97.3102 18.8272H96.3668C95.1353 18.8272 94.5424 18.108 94.5424 17.0606V15.4881H97.3102V16.42H103.191V13.9554H96.4455C95.3686 13.9554 94.5928 13.2232 94.5928 12.2082V8.63337C94.5928 7.55177 95.4373 6.78725 96.4638 6.78725H104.176C105.218 6.78725 105.939 7.57303 105.939 8.7101V10.1467H103.191V9.19451H97.3102V11.5666H104.037C105.03 11.5666 105.939 12.2304 105.939 13.508V16.9441C105.939 18.1154 105.297 18.8272 104.094 18.8272H97.3102Z%27 fill=%27white%27/><path fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M83.5521 12.3088H89.5295V9.18788H83.5521V12.3088ZM80.7645 18.8211V6.77925H90.2854C91.5572 6.77925 92.2965 7.52343 92.2965 8.79916V12.8436C92.2965 13.7754 91.4813 14.6158 89.8993 14.6158C89.8097 14.6213 89.7191 14.6158 89.6249 14.6158L92.3962 18.8211H89.3376L86.7098 14.7036H83.5524V18.8211H80.7645Z%27 fill=%27white%27/><path fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M67.1551 18.8209V6.78005H78.5325V9.1873H69.9027V11.5788H77.3019V13.9288H69.9027V16.4128H78.5535V18.8209H67.1551Z%27 fill=%27white%27/><path fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M60.8901 14.159L58.7025 9.05514L56.5652 14.159H60.8901ZM54.6084 18.8209H51.5333L56.8198 6.78005H60.605L65.929 18.8209H62.8933L61.8456 16.422H55.624L54.6084 18.8209Z%27 fill=%27white%27/><path fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M36.1834 18.821V6.78015H39.3537L43.3721 15.7778L47.3311 6.78015H50.3687V18.821H47.7538V11.8165L44.7363 18.821H41.9494L38.8935 11.8544V18.821H36.1834Z%27 fill=%27white%27/><path fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M24.2667 23.0356C24.2667 24.673 22.9596 26 21.3477 26H2.91987C1.30705 26 0 24.673 0 23.0356V2.9653C0 1.32788 1.30705 0 2.91987 0H21.3477C22.9596 0 24.2667 1.32788 24.2667 2.9653V23.0356Z%27 fill=%27%2342B0D5%27/><path fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M15.9403 12.6561L20.653 6.5436L20.6385 6.52421L13.8281 9.91592L12.1455 2.29405H12.1217L10.4399 9.91592L3.62953 6.52421L3.61418 6.5436L8.32778 12.6561L1.51736 16.0487L1.52247 16.0725H9.08127L7.39955 23.6952L7.42086 23.7058L12.1336 17.5933L16.8463 23.7058L16.8677 23.6944L15.1868 16.0725H22.7456L22.7507 16.0487L15.9403 12.6561Z%27 fill=%27white%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.analytics-wrapper {
  /* ── Light theme tokens (default) ──────────────────────────────────── */
  --an-bg: #f6f7f9;
  --an-surface: #ffffff;
  --an-surface-alt: #f3f4f6;
  --an-surface-hover: #edf1f5;
  --an-border: #e5e4df;
  --an-border-soft: #edece7;
  --an-text: #0b0b0c;
  --an-text-muted: #55534e;
  --an-text-faint: #8a8880;
  --an-accent: #2a78d6;
  --an-accent-hover: #1c5cab;
  --an-accent-soft: #e8f4fc;
  --an-accent-contrast: #ffffff;
  --an-good: #0ca30c;
  --an-warning: #fab219;
  --an-serious: #ec835a;
  --an-critical: #d03b3b;
  --an-warning-bg: #fff8e6;
  --an-warning-text: #6b4d00;
  --an-shadow-sm: 0 1px 2px rgba(16, 24, 40, 0.05), 0 1px 1px rgba(16, 24, 40, 0.03);
  --an-shadow-md: 0 10px 28px rgba(16, 24, 40, 0.09);
  --an-shadow-accent: 0 10px 26px rgba(42, 120, 214, 0.16);
  --an-radius-lg: 16px;
  --an-radius: 10px;
  --an-radius-sm: 8px;

  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: var(--an-bg);
  color-scheme: light;
}

.analytics-wrapper[data-theme="dark"] {
  --an-bg: #0e1013;
  --an-surface: #17191e;
  --an-surface-alt: #1d2027;
  --an-surface-hover: #262a32;
  --an-border: #2b2e36;
  --an-border-soft: #22252c;
  --an-text: #f1f2f4;
  --an-text-muted: #b7bac1;
  --an-text-faint: #80838d;
  --an-accent: #5b9ce6;
  --an-accent-hover: #7db1ec;
  --an-accent-soft: #1c3350;
  --an-accent-contrast: #08131f;
  --an-good: #35d45b;
  --an-warning: #ffcc4d;
  --an-serious: #ff9a6b;
  --an-critical: #ff6161;
  --an-warning-bg: #362a0c;
  --an-warning-text: #ffdf9e;
  --an-shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.4);
  --an-shadow-md: 0 12px 30px rgba(0, 0, 0, 0.5);
  --an-shadow-accent: 0 12px 28px rgba(91, 156, 230, 0.22);
  color-scheme: dark;

  /* ── MDS component tokens ──────────────────────────────────────────
     McTopBar/McTable/McSelect/etc. are shadow-DOM web components whose
     internal styles read these --mds_brand_appearance_* vars (aliased
     inside each component's own :host block into --mds_foundations_*).
     Custom properties inherit through shadow boundaries, so overriding
     them here re-themes the MDS components too — app-wide default is
     the light bundle imported in index.js, this is the dark diff of
     @maersk-global/mds-design-tokens maersk/light vs maersk/dark. */
  --mds_brand_appearance_neutral_default_text-color: rgb(240, 240, 240);
  --mds_brand_appearance_neutral_default_background-color: rgb(20, 20, 20);
  --mds_brand_appearance_neutral_default_on-background-color: rgb(240, 240, 240);
  --mds_brand_appearance_neutral_default_border-color: rgb(76, 76, 76);
  --mds_brand_appearance_neutral_default_opacity_border-color: rgba(255, 255, 255, 0.24);
  --mds_brand_appearance_neutral_weakest_text-color: rgb(138, 138, 138);
  --mds_brand_appearance_neutral_weakest_background-color: rgb(33, 33, 33);
  --mds_brand_appearance_neutral_weakest_on-background-color: rgb(240, 240, 240);
  --mds_brand_appearance_neutral_weak_text-color: rgb(212, 212, 212);
  --mds_brand_appearance_neutral_weak_background-color: rgb(54, 54, 54);
  --mds_brand_appearance_neutral_weak_on-background-color: rgb(240, 240, 240);
  --mds_brand_appearance_neutral_weak_border-color: rgb(54, 54, 54);
  --mds_brand_appearance_neutral_weak_opacity_background-color: rgba(255, 255, 255, 0.14);
  --mds_brand_appearance_neutral_strong_background-color: rgb(76, 76, 76);
  --mds_brand_appearance_neutral_strong_on-background-color: rgb(240, 240, 240);
  --mds_brand_appearance_neutral_strongest_background-color: rgb(106, 106, 106);
  --mds_brand_appearance_neutral_strongest_on-background-color: rgb(240, 240, 240);
  --mds_brand_appearance_neutral_inverse_text-color: rgb(20, 20, 20);
  --mds_brand_appearance_neutral_inverse_background-color: rgb(255, 255, 255);
  --mds_brand_appearance_neutral_inverse_on-background-color: rgb(20, 20, 20);
  --mds_brand_appearance_neutral_inverse_border-color: rgb(20, 20, 20);
  --mds_brand_appearance_primary_default_text-color: rgb(240, 240, 240);
  --mds_brand_appearance_primary_default_background-color: rgb(255, 255, 255);
  --mds_brand_appearance_primary_default_on-background-color: rgb(20, 20, 20);
  --mds_brand_appearance_primary_default_border-color: rgb(255, 255, 255);
  --mds_brand_appearance_primary_default_link-color: rgb(66, 176, 213);
  --mds_brand_appearance_primary_weak_background-color: rgb(54, 54, 54);
  --mds_brand_appearance_primary_weak_on-background-color: rgb(240, 240, 240);
  --mds_brand_appearance_primary_weak_border-color: rgb(54, 54, 54);
  --mds_brand_appearance_secondary_default_text-color: rgb(66, 176, 213);
  --mds_brand_appearance_secondary_weak_background-color: rgb(12, 36, 44);
  --mds_brand_appearance_secondary_weak_on-background-color: rgb(158, 215, 234);
  --mds_brand_appearance_secondary_weak_border-color: rgba(23, 69, 84);
  --mds_brand_appearance_success_default_text-color: rgb(127, 209, 117);
  --mds_brand_appearance_success_default_background-color: rgb(127, 209, 117);
  --mds_brand_appearance_success_default_on-background-color: rgb(20, 20, 20);
  --mds_brand_appearance_success_default_border-color: rgb(127, 209, 117);
  --mds_brand_appearance_success_weak_background-color: rgb(18, 51, 17);
  --mds_brand_appearance_success_weak_on-background-color: rgb(216, 242, 213);
  --mds_brand_appearance_success_weak_border-color: rgb(27, 70, 23);
  --mds_brand_appearance_warning_default_text-color: rgb(242, 205, 89);
  --mds_brand_appearance_warning_default_background-color: rgb(242, 205, 89);
  --mds_brand_appearance_warning_default_on-background-color: rgb(20, 20, 20);
  --mds_brand_appearance_warning_default_border-color: rgb(242, 205, 89);
  --mds_brand_appearance_warning_weak_background-color: rgb(63, 51, 16);
  --mds_brand_appearance_warning_weak_on-background-color: rgb(253, 237, 186);
  --mds_brand_appearance_warning_weak_border-color: rgb(83, 68, 19);
  --mds_brand_appearance_error_default_text-color: rgb(255, 162, 166);
  --mds_brand_appearance_error_default_background-color: rgb(255, 162, 166);
  --mds_brand_appearance_error_default_on-background-color: rgb(20, 20, 20);
  --mds_brand_appearance_error_default_border-color: rgb(255, 162, 166);
  --mds_brand_appearance_error_weak_background-color: rgb(80, 23, 33);
  --mds_brand_appearance_error_weak_on-background-color: rgb(247, 229, 230);
  --mds_brand_appearance_error_weak_border-color: rgb(104, 28, 37);
  --mds_brand_appearance_info_default_text-color: rgb(22, 134, 189);
  --mds_brand_appearance_info_default_border-color: rgb(22, 134, 189);
  --mds_brand_appearance_info_weak_background-color: rgb(0, 36, 61);
  --mds_brand_appearance_info_weak_on-background-color: rgb(195, 228, 243);
  --mds_brand_appearance_info_weak_border-color: rgb(0, 62, 98);
  --mds_brand_appearance_static_logo_url: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  --mds_brand_appearance_opacity_default_10: rgba(20, 20, 20, 0.1);
  --mds_brand_appearance_opacity_default_30: rgba(20, 20, 20, 0.3);
  --mds_brand_appearance_opacity_default_50: rgba(20, 20, 20, 0.5);
  --mds_brand_appearance_opacity_default_70: rgba(20, 20, 20, 0.7);
  --mds_brand_appearance_opacity_default_90: rgba(20, 20, 20, 0.9);
  --mds_brand_appearance_opacity_inverse_10: rgba(255, 255, 255, 0.1);
  --mds_brand_appearance_opacity_inverse_30: rgba(255, 255, 255, 0.3);
  --mds_brand_appearance_opacity_inverse_50: rgba(255, 255, 255, 0.5);
  --mds_brand_appearance_opacity_inverse_70: rgba(255, 255, 255, 0.7);
  --mds_brand_appearance_opacity_inverse_90: rgba(255, 255, 255, 0.9);
  --mds_brand_appearance_state_neutral_default_hover_background-color: rgb(54, 54, 54);
  --mds_brand_appearance_state_neutral_default_hover_border-color: rgb(106, 106, 106);
  --mds_brand_appearance_state_neutral_default_active_background-color: rgb(76, 76, 76);
  --mds_brand_appearance_state_neutral_default_active_border-color: rgb(138, 138, 138);
  --mds_brand_appearance_state_neutral_weakest_opacity_hover_background-color: rgba(255, 255, 255, 0.14);
  --mds_brand_appearance_state_neutral_weakest_opacity_active_background-color: rgba(255, 255, 255, 0.24);
  --mds_brand_appearance_state_neutral_weak_opacity_hover_background-color: rgba(255, 255, 255, 0.24);
  --mds_brand_appearance_state_neutral_weak_opacity_active_background-color: rgba(255, 255, 255, 0.32);
  --mds_brand_appearance_state_neutral_strongest_active_background-color: rgb(179, 179, 179);
  --mds_brand_appearance_state_neutral_inverse_opacity_hover_background-color: rgba(20, 20, 20, 0.06);
  --mds_brand_appearance_state_neutral_inverse_opacity_active_background-color: rgba(20, 20, 20, 0.12);
  --mds_brand_appearance_state_primary_default_hover_background-color: rgb(226, 226, 226);
  --mds_brand_appearance_state_primary_default_hover_border-color: rgb(226, 226, 226);
  --mds_brand_appearance_state_primary_default_active_background-color: rgb(212, 212, 212);
  --mds_brand_appearance_state_primary_default_active_border-color: rgb(212, 212, 212);
  --mds_brand_appearance_state_primary_weakest_opacity_hover_background-color: rgba(255, 255, 255, 0.14);
  --mds_brand_appearance_state_primary_weakest_opacity_active_background-color: rgba(255, 255, 255, 0.24);
  --mds_brand_appearance_state_secondary_weakest_opacity_hover_background-color: rgba(66, 176, 213, 0.16);
  --mds_brand_appearance_state_secondary_weakest_opacity_active_background-color: rgba(66, 176, 213, 0.28);
  --mds_brand_appearance_state_success_default_hover_background-color: rgb(92, 189, 82);
  --mds_brand_appearance_state_success_default_active_background-color: rgb(155, 223, 146);
  --mds_brand_appearance_state_warning_default_hover_background-color: rgb(223, 187, 75);
  --mds_brand_appearance_state_warning_default_active_background-color: rgb(251, 216, 107);
  --mds_brand_appearance_state_error_default_hover_background-color: rgb(251, 130, 136);
  --mds_brand_appearance_state_error_default_active_background-color: rgb(253, 187, 190);
  --mds_brand_appearance_state_error_weakest_opacity_hover_background-color: rgba(139, 39, 48, 0.16);
  --mds_brand_appearance_state_error_weakest_opacity_active_background-color: rgba(139, 39, 48, 0.4);
  --mds_brand_appearance_state_focus_default_shadow_color: rgb(0, 62, 98);
  --mds_brand_appearance_state_focus_vanity_shadow_color: rgb(0, 62, 98);

  /* ── MDS foundation tokens (re-declared, not just referenced) ───────
     These are var() aliases onto the --mds_brand_appearance_* tokens
     above, but the global light bundle (index.js) already declares
     them once at :root — CSS freezes a custom property's resolved
     value at the scope where it's declared and inherits that frozen
     value, so redefining --mds_brand_appearance_* deeper in the tree
     does NOT retroactively re-resolve a --mds_foundations_* alias
     declared only at :root. Re-declaring the same alias expression
     here forces it to re-resolve using the dark values above. */
  --mds_foundations_body_background-color: var(--mds_brand_appearance_neutral_default_background-color);
  --mds_foundations_body_text-color: var(--mds_brand_appearance_neutral_default_text-color);
  --mds_foundations_breadcrumb_item_text-color: var(--mds_brand_appearance_neutral_weak_text-color);
  --mds_foundations_breadcrumb_separator_text-color: var(--mds_brand_appearance_neutral_weakest_text-color);
  --mds_foundations_horizontal-rule_border-color: var(--mds_brand_appearance_neutral_default_border-color);
  --mds_foundations_link_default_text-color: var(--mds_brand_appearance_primary_default_link-color);
  --mds_foundations_modal_background-color: var(--mds_brand_appearance_neutral_default_background-color);
  --mds_foundations_modal_close_background-color: var(--mds_brand_appearance_opacity_default_50);
  --mds_foundations_modal_footer_background-color: var(--mds_brand_appearance_neutral_weakest_background-color);
  --mds_foundations_table_border-color: var(--mds_brand_appearance_neutral_default_border-color);
  --mds_foundations_table_cell_background-color: var(--mds_brand_appearance_neutral_default_background-color);
  --mds_foundations_table_cell_text-color: var(--mds_brand_appearance_neutral_default_on-background-color);
  --mds_foundations_table_cell_hover_background-color: var(--mds_brand_appearance_state_neutral_default_hover_background-color);
  --mds_foundations_table_cell_hover_text-color: var(--mds_brand_appearance_neutral_default_on-background-color);
  --mds_foundations_table_cell_selected_background-color: var(--mds_brand_appearance_primary_weak_background-color);
  --mds_foundations_table_cell_selected_text-color: var(--mds_brand_appearance_primary_weak_on-background-color);
  --mds_foundations_table_header-cell_background-color: var(--mds_brand_appearance_neutral_weakest_background-color);
  --mds_foundations_table_header-cell_text-color: var(--mds_brand_appearance_neutral_weakest_on-background-color);
  --mds_foundations_table_header-cell_sort_hover_background-color: var(--mds_brand_appearance_state_neutral_default_hover_background-color);
  --mds_foundations_table_header-cell_sort_active_background-color: var(--mds_brand_appearance_state_neutral_default_active_background-color);
  --mds_foundations_table_zebra-stripe_background-color: var(--mds_brand_appearance_neutral_weakest_background-color);
  --mds_foundations_table_zebra-stripe_text-color: var(--mds_brand_appearance_neutral_weakest_on-background-color);
  --mds_foundations_table_caption_text-color: var(--mds_brand_appearance_neutral_default_on-background-color);
  --mds_foundations_table_subtext_text-color: var(--mds_brand_appearance_neutral_weak_text-color);
}

.analytics-wrapper,
.analytics-wrapper * {
  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}

.analytics-topbar {
  padding-left: 20px;
  padding-right: 20px;
  height: 64px;
  margin-top: -5px;
  border-bottom: 1px solid var(--an-border);
  flex-shrink: 0;
  background: var(--an-surface);
}

/* Top bar + toolbar (filters, section nav, refresh) stay pinned while
   scrolling. --an-toolbar-top / --an-sticky-offset are measured in Analytics.js. */
.analytics-topbar-wrap {
  position: sticky;
  top: 0;
  z-index: 21;
  display: flow-root;
  background: var(--an-surface);
  flex-shrink: 0;
}

.analytics-intro {
  padding: 16px 28px 10px;
}

.analytics-toolbar {
  position: sticky;
  top: var(--an-toolbar-top, 0px);
  z-index: 20;
  background: var(--an-bg);
  border-bottom: 1px solid var(--an-border);
  flex-shrink: 0;
}

.analytics-toolbar-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 28px;
}

.analytics-filters-toggle {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  flex-shrink: 0;
  height: 34px;
  padding: 0 12px;
  border: 1px solid var(--an-border);
  border-radius: var(--an-radius-sm);
  background: var(--an-surface);
  color: var(--an-text);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: var(--an-shadow-sm);
}

.analytics-filters-toggle:hover,
.analytics-filters-toggle-open {
  border-color: var(--an-accent);
  color: var(--an-accent);
}

.analytics-filters-badge {
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  background: var(--an-accent);
  color: var(--an-accent-contrast);
  font-size: 11px;
  line-height: 18px;
  text-align: center;
}

.analytics-filters-trend {
  padding-left: 7px;
  border-left: 1px solid var(--an-border);
  color: var(--an-text-muted);
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}

/* Side panel docked to the right edge, under the pinned toolbar. It is narrow so
   the data stays visible next to it, and scrolls internally if the filters are
   taller than the window. On wide screens the page reflows beside it (see the
   .analytics-filters-open rules below), so nothing is covered at all. */
.analytics-wrapper {
  --an-filter-panel-w: 420px;
}

.analytics-filter-panel {
  position: absolute;
  top: 100%;
  right: 0;
  width: min(var(--an-filter-panel-w), 100%);
  max-height: calc(100vh - var(--an-sticky-offset, 72px) - 16px);
  overflow-y: auto;
  padding: 10px 14px 14px;
  background: var(--an-bg);
  border: 1px solid var(--an-border);
  border-top: none;
  border-radius: 0 0 var(--an-radius) var(--an-radius);
  box-shadow: var(--an-shadow-md);
}

.analytics-filter-panel[hidden] {
  display: none;
}

.analytics-filter-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.analytics-filter-panel-title {
  font-size: 14px;
  font-weight: 700;
  color: var(--an-text);
}

.analytics-filter-panel-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: var(--an-radius-sm);
  background: transparent;
  cursor: pointer;
}

.analytics-filter-panel-close:hover {
  background: var(--an-surface-hover, var(--an-accent-soft));
}

/* Narrow-column layout for the shared FilterBar: everything stacks, and the
   individual filter inputs sit two per row. */
.analytics-filter-panel .analytics-filter-bar {
  margin-bottom: 0;
  padding: 12px;
  box-shadow: none;
}

.analytics-filter-panel .analytics-filter-top-row {
  flex-direction: column;
  align-items: stretch;
  gap: 12px;
}

.analytics-filter-panel .analytics-trend-select {
  min-width: 0;
  width: 100%;
}

.analytics-filter-panel .analytics-filter-row {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: start;
  gap: 12px;
  margin-top: 14px;
}

.analytics-filter-panel .analytics-filter-field {
  min-width: 0;
}

.analytics-filter-panel .analytics-filter-field-hint {
  max-width: none;
}

.analytics-filter-panel .analytics-apply-btn {
  grid-column: 1 / -1;
  width: 100%;
}

.analytics-filter-panel .analytics-filter-chips {
  margin-top: 12px;
}

/* The panel scrolls (overflow), which would crop FilterSelector's absolutely
   positioned list. Inside the panel it flows in the layout instead, so the
   panel grows to show it. Stays \`relative\` to keep its z-index above the
   click-away overlay. */
.analytics-filter-panel .fsel-dropdown-wrapper {
  width: 100%;
}

.analytics-filter-panel .fsel-dropdown {
  position: relative;
  top: auto;
  left: auto;
  min-width: 0;
  max-height: none;
  margin-top: 8px;
  box-shadow: none;
}

/* Wide screens: make room for the panel so the dashboard reflows beside it. */
.analytics-container,
.analytics-intro {
  transition: padding-right 0.2s ease;
}

@media (min-width: 1100px) {
  .analytics-filters-open .analytics-container,
  .analytics-filters-open .analytics-intro {
    padding-right: calc(28px + var(--an-filter-panel-w) + 16px);
  }
}

/* Compact screens (phones / short windows): only the toolbar stays pinned. */
@media (max-width: 720px), (max-height: 640px) {
  .analytics-topbar-wrap {
    position: static;
  }
}

@media (max-width: 720px) {
  .analytics-intro {
    padding: 12px 12px 8px;
  }

  .analytics-main-header {
    font-size: 18px;
  }

  .analytics-toolbar-row {
    padding: 6px 12px;
    gap: 8px;
  }

  .analytics-refresh-label {
    display: none;
  }

  .analytics-refresh-btn {
    padding: 0 10px;
  }

  /* Phones: full-width sheet, capped so part of the data stays visible below it. */
  .analytics-filter-panel {
    left: 0;
    width: auto;
    max-height: min(60vh, calc(100vh - var(--an-sticky-offset, 72px) - 12px));
    padding: 8px 10px 12px;
    border-left: none;
    border-right: none;
    border-radius: 0;
  }

  .analytics-filter-panel .analytics-filter-row {
    grid-template-columns: minmax(0, 1fr);
  }
}

@media (max-width: 520px) {
  .analytics-filters-trend {
    display: none;
  }
}

.analytics-container {
  flex: 1 1;
  background-color: var(--an-bg);
  padding: 4px 28px 40px;
}

@media (max-width: 720px) {
  .analytics-container {
    padding: 4px 12px 32px;
  }
}


.analytics-main-header {
  font-size: 21px;
  font-weight: 700;
  letter-spacing: -0.015em;
  color: var(--an-text);
  margin: 0;
}

.analytics-subheader {
  margin: 5px 0 0;
  font-size: 13px;
  line-height: 1.45;
  color: var(--an-text-muted);
  max-width: 640px;
}


.analytics-refresh-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 14px;
  border: 1px solid var(--an-border);
  border-radius: var(--an-radius-sm);
  background: var(--an-surface);
  color: var(--an-text);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: var(--an-shadow-sm);
}

.analytics-refresh-btn:hover {
  border-color: var(--an-accent);
  color: var(--an-accent);
}

/* ── Theme toggle ────────────────────────────────────────────────────── */

.theme-toggle-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 0 12px;
  border: 1px solid var(--an-border);
  border-radius: var(--an-radius-sm);
  background: var(--an-surface);
  color: var(--an-text-muted);
  cursor: pointer;
  box-shadow: var(--an-shadow-sm);
}

.theme-toggle-btn:hover {
  border-color: var(--an-accent);
  color: var(--an-accent);
}

.analytics-back-btn {
  background: none;
  border: 1px solid var(--an-border);
  border-radius: var(--an-radius-sm);
  padding: 6px 14px;
  font-size: 13px;
  color: var(--an-text);
  cursor: pointer;
}

.analytics-back-btn:hover {
  border-color: var(--an-accent);
  color: var(--an-accent);
}

/* ── Section nav ─────────────────────────────────────────────── */

.section-nav {
  display: flex;
  flex: 1 1;
  min-width: 0;
  gap: 8px;
  flex-wrap: nowrap;
  overflow-x: auto;
  padding: 2px 16px 2px 0;
  scrollbar-width: none;
  mask-image: linear-gradient(to right, #000 calc(100% - 20px), transparent);
}

.section-nav::-webkit-scrollbar {
  display: none;
}

.section-nav-link {
  flex-shrink: 0;
  padding: 6px 14px;
  border-radius: 16px;
  background: var(--an-surface);
  border: 1px solid var(--an-border);
  color: var(--an-text-muted);
  font-size: 12.5px;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
  transition: all 0.15s ease;
}

.section-nav-link:hover {
  border-color: var(--an-accent);
  color: var(--an-accent);
}

.section-nav-link-active {
  background: var(--an-accent);
  border-color: var(--an-accent);
  color: var(--an-accent-contrast);
}

/* ── Dashboard sections ─────────────────────────────────────────────── */

.analytics-section {
  scroll-margin-top: var(--an-sticky-offset, 260px);
  padding-top: 20px;
}

.analytics-section-header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}

.analytics-section-heading {
  font-family: "Maersk Headline", MaerskText, sans-serif;
  font-size: 15px;
  font-weight: 700;
  color: var(--an-text);
  margin: 0;
}

.analytics-section-caption {
  font-size: 12px;
  color: var(--an-text-faint);
  white-space: nowrap;
}

/* ── Collapsible tables ─────────────────────────────────────────────── */

.analytics-collapsible summary {
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  color: var(--an-accent);
  padding: 4px 0 12px;
  list-style: none;
}

.analytics-collapsible summary::-webkit-details-marker {
  display: none;
}

.analytics-collapsible summary::before {
  content: "▸ ";
}

.analytics-collapsible[open] summary::before {
  content: "▾ ";
}

/* Breakdown tables: scroll inside the card (both ways) with an always-visible
   scrollbar, instead of cropping wide columns or growing 40+ rows tall.
   scrollbar-color inherits, so it also reaches the scroller inside the MDS
   table's shadow DOM and stops macOS from hiding it as an overlay bar. */
.analytics-collapsible {
  scrollbar-color: var(--an-text-faint) var(--an-surface-hover, transparent);
}

.analytics-collapsible mc-table {
  display: block;
  max-width: 100%;
  max-height: 480px;
  overflow: auto;
  scrollbar-width: thin;
}

.analytics-collapsible mc-table::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

.analytics-collapsible mc-table::-webkit-scrollbar-thumb {
  background: var(--an-text-faint);
  border-radius: 5px;
}

.analytics-collapsible mc-table::-webkit-scrollbar-track {
  background: var(--an-surface-hover, transparent);
}

/* ── Timeliness tabs (Approval / PO / Invoice share one detail panel) ──── */

.tl-tab-strip {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 18px;
  padding-top: 14px;
  border-top: 1px solid var(--an-border-soft);
}

.tl-tab {
  padding: 8px 16px;
  border-radius: var(--an-radius-sm);
  border: 1px solid var(--an-border);
  background: var(--an-surface);
  color: var(--an-text-muted);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
}

.tl-tab:hover {
  border-color: var(--an-accent);
  color: var(--an-accent);
}

.tl-tab-active {
  background: var(--an-accent);
  border-color: var(--an-accent);
  color: var(--an-accent-contrast);
}

.tl-detail-header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--an-border-soft);
}

.tl-detail-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--an-text);
  margin: 0;
}

.cx-timeliness-card {
  padding-top: 12px;
}

.cx-sla-tabs {
  margin-top: 0;
  padding-top: 0;
  border-top: 0;
  margin-bottom: 18px;
}

.cx-sla-rule-row,
.cx-sla-table-heading {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
}

.cx-sla-rule-row {
  margin-bottom: 16px;
}

.cx-sla-rule-row .analytics-section-caption {
  white-space: normal;
  text-align: right;
}

.cx-sla-scope-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 18px;
}

.cx-sla-scope-label {
  color: var(--an-text-muted);
  font-size: 13px;
  font-weight: 600;
}

.cx-sla-scope-control {
  display: inline-flex;
  gap: 3px;
  padding: 3px;
  border: 1px solid var(--an-border);
  border-radius: var(--an-radius-sm);
  background: var(--an-surface-alt);
}

.cx-sla-scope-button {
  min-height: 32px;
  padding: 0 12px;
  border: 1px solid transparent;
  border-radius: 6px;
  background: transparent;
  color: var(--an-text-muted);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.cx-sla-scope-button:hover {
  color: var(--an-accent);
}

.cx-sla-scope-button-active {
  border-color: var(--an-border);
  background: var(--an-surface);
  color: var(--an-accent);
  box-shadow: var(--an-shadow-sm);
}

.cx-sla-stat-row {
  margin-top: 14px;
  margin-bottom: 8px;
}

.cx-sla-kpi-button {
  min-width: 0;
  padding: 0;
  border: 0;
  border-radius: var(--an-radius-lg);
  background: transparent;
  color: inherit;
  text-align: left;
  cursor: pointer;
}

.cx-sla-kpi-button .stat-tile {
  height: 100%;
}

.cx-sla-kpi-button:hover .stat-tile {
  box-shadow: var(--an-shadow-md);
  transform: translateY(-1px);
}

.cx-sla-kpi-button-active .stat-tile {
  outline: 2px solid var(--an-accent);
  outline-offset: 2px;
}

.cx-sla-kpi-button:focus-visible {
  outline: 2px solid var(--an-accent);
  outline-offset: 3px;
}

.cx-sla-stat-row .stat-tile-label {
  min-height: 0;
}

.cx-sla-stat-row .stat-tile-subvalue {
  line-height: 1.5;
}

.cx-sla-rate-note,
.cx-sla-empty {
  margin: 8px 0 18px;
  color: var(--an-text-faint);
  font-size: 12px;
}

.cx-sla-table-wrap {
  margin-top: 20px;
  padding-top: 18px;
  border-top: 1px solid var(--an-border-soft);
}

.cx-sla-table-heading .analytics-section-title {
  margin-bottom: 10px;
}

.cx-sla-table-scroll {
  max-width: 100%;
  max-height: 480px;
  overflow: auto;
  scrollbar-color: var(--an-text-faint) var(--an-surface-hover, transparent);
  scrollbar-width: thin;
}

.cx-sla-table-scroll mc-table {
  display: block;
  max-width: 100%;
  max-height: 480px;
  overflow: auto;
  scrollbar-width: thin;
}

.cx-sla-pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 12px;
}

.cx-sla-page-button {
  min-height: 34px;
  padding: 0 14px;
  border: 1px solid var(--an-border);
  border-radius: var(--an-radius-sm);
  background: var(--an-surface);
  color: var(--an-accent);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.cx-sla-page-button:disabled {
  cursor: not-allowed;
  opacity: 0.65;
}

.cx-sla-page-indicator {
  color: var(--an-text-muted);
  font-size: 12px;
  font-variant-numeric: tabular-nums;
}

@media (max-width: 640px) {
  .cx-sla-rule-row,
  .cx-sla-table-heading {
    align-items: flex-start;
    flex-direction: column;
    gap: 6px;
  }

  .cx-sla-rule-row .analytics-section-caption {
    text-align: left;
  }

  .cx-sla-tabs .tl-tab {
    flex: 1 1 100%;
  }

  .cx-sla-stat-row {
    grid-template-columns: minmax(0, 1fr);
  }
}

/* ── Filter bar ─────────────────────────────────────────────────────── */

.analytics-filter-bar {
  background: var(--an-surface);
  border: 1px solid var(--an-border);
  border-radius: var(--an-radius);
  padding: 16px 18px;
  margin-bottom: 20px;
  box-shadow: var(--an-shadow-sm);
}

.analytics-filter-row {
  display: flex;
  align-items: flex-end;
  gap: 14px;
  flex-wrap: wrap;
}

.analytics-filter-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.analytics-filter-field-hint {
  font-size: 11px;
  color: var(--an-text-muted);
  max-width: 260px;
  line-height: 1.3;
}

.analytics-filter-top-row {
  display: flex;
  align-items: flex-end;
  gap: 24px;
  flex-wrap: wrap;
}

.analytics-filter-top-row .fsel-row {
  margin-bottom: 0;
}

.analytics-trend-select {
  min-width: 160px;
}

.analytics-apply-btn {
  height: 40px;
  padding: 0 18px;
  border: none;
  border-radius: var(--an-radius-sm);
  background: var(--an-accent);
  color: var(--an-accent-contrast);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.analytics-apply-btn:hover {
  background: var(--an-accent-hover);
}

.analytics-filter-chips {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 14px;
}

.analytics-filter-chips-label {
  font-size: 12.5px;
  color: var(--an-text-muted);
}

.analytics-filter-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  background: var(--an-accent-soft);
  border: 1px solid var(--an-accent);
  border-radius: 16px;
  font-size: 12.5px;
  color: var(--an-accent);
}

.analytics-filter-chip-remove {
  cursor: pointer;
}

/* ── Warning banner ─────────────────────────────────────────────────── */

.analytics-warning-banner {
  background: var(--an-warning-bg);
  border: 1px solid var(--an-warning);
  color: var(--an-warning-text);
  border-radius: var(--an-radius-sm);
  padding: 10px 16px;
  font-size: 13px;
  margin-bottom: 18px;
}

/* ── Stat tiles ──────────────────────────────────────────────────────── */

.stat-tile-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
  gap: 14px;
  margin-bottom: 22px;
}

.stat-tile {
  background: var(--an-surface);
  border: 1px solid var(--an-border);
  border-left: 3px solid var(--an-accent-soft);
  border-radius: var(--an-radius-lg);
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  box-shadow: var(--an-shadow-sm);
  transition: box-shadow 0.15s ease, transform 0.15s ease;
}

.stat-tile:hover {
  box-shadow: var(--an-shadow-md);
  transform: translateY(-1px);
}

.stat-tile-label {
  font-size: 11.5px;
  font-weight: 600;
  color: var(--an-text-faint);
  text-transform: uppercase;
  letter-spacing: 0.03em;
  line-height: 1.3;
  min-height: 2.6em;
  display: flex;
  align-items: flex-start;
}

.stat-tile-value {
  font-size: 28px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--an-text);
}

.stat-tile-subvalue {
  font-size: 12px;
  color: var(--an-text-faint);
}

.stat-tile-good { border-left-color: var(--an-good); }
.stat-tile-warning { border-left-color: var(--an-warning); }
.stat-tile-serious { border-left-color: var(--an-serious); }
.stat-tile-critical { border-left-color: var(--an-critical); }

/* Below ~2 columns' worth of the 190px basis, auto-fit would drop to a
   single column and stack every tile vertically — force 2-up instead so
   the row stays compact on narrow viewports. */
@media (max-width: 640px) {
  .stat-tile-row {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }

  .stat-tile {
    padding: 12px 14px;
    gap: 4px;
  }

  .stat-tile-value {
    font-size: 22px;
  }
}

@media (max-width: 380px) {
  .stat-tile-value {
    font-size: 19px;
  }
}

/* ── Overview tab ────────────────────────────────────────────────────── */

.overview-card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 16px;
}

.overview-card {
  background: var(--an-surface);
  border: 1px solid var(--an-border);
  border-radius: var(--an-radius-lg);
  padding: 20px 22px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  box-shadow: var(--an-shadow-sm);
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
}

.overview-card-clickable {
  cursor: pointer;
}

.overview-card-clickable:hover {
  transform: translateY(-2px);
  border-color: var(--an-accent);
  box-shadow: var(--an-shadow-accent);
}

.overview-card-cx-timeliness {
  box-sizing: border-box;
  width: 410px;
  max-width: 100%;
}

.overview-card-cx-timeliness .overview-card-metrics {
  grid-template-columns: minmax(0, 1.4fr) minmax(0, 1fr);
  column-gap: 28px;
}

.overview-card-cx-timeliness .overview-card-metric-label {
  font-size: 10px;
  letter-spacing: 0.02em;
  white-space: normal;
  overflow-wrap: anywhere;
}

.overview-card-title {
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--an-text-muted);
  margin: 0;
}

.overview-card-metrics {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(96px, 1fr));
  gap: 14px 20px;
  padding-top: 10px;
  border-top: 1px solid var(--an-border-soft);
}

.overview-card-metric-label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  color: var(--an-text-faint);
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.overview-card-metric-value {
  display: block;
  font-size: 21px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--an-text);
}

.overview-card-note {
  font-size: 11.5px;
  color: var(--an-text-faint);
  font-style: italic;
}

.overview-card-loading,
.overview-card-error {
  font-size: 12.5px;
  color: var(--an-text-faint);
}

.overview-card-error {
  color: var(--an-critical);
}

/* ── Side-by-side metric comparison (Pending Approval vs Pending PO) ─── */

.aging-compare-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 28px;
  margin-bottom: 28px;
}

.aging-compare-col {
  scroll-margin-top: 76px;
}

.aging-compare-col-header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--an-border-soft);
}

.aging-compare-col-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--an-text);
  margin: 0;
}

.aging-compare-subtitle {
  margin-top: 18px;
}

@media (max-width: 860px) {
  .aging-compare-grid {
    grid-template-columns: 1fr;
  }
}

/* ── Dashboard section cards (chart + table) ────────────────────────── */

.analytics-section-card {
  background: var(--an-surface);
  border: 1px solid var(--an-border);
  border-radius: var(--an-radius-lg);
  padding: 22px 24px;
  margin-bottom: 20px;
  box-shadow: var(--an-shadow-sm);
}

.analytics-section-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--an-text);
  margin: 0 0 12px;
}

/* Two side-by-side charts share one row on desktop instead of each
   claiming a full-width row; collapses to stacked below the width where
   the funnel's fixed label/value columns would otherwise get too cramped. */
.analytics-charts-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
  align-items: start;
}

.analytics-charts-row .analytics-section-card {
  margin-bottom: 0;
  min-width: 0;
}

@media (max-width: 1080px) {
  .analytics-charts-row {
    grid-template-columns: 1fr;
  }
}

.critical-materials-card {
  border-left: 3px solid var(--an-critical);
}

/* ── Material Spend & Cost Spike filters ────────────────────────────── */

.spike-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: flex-end;
}

.spike-filter {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 200px;
}

.spike-filter-label {
  font-size: 12px;
  font-weight: 600;
  color: var(--an-text-muted);
}

.spike-filter-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  height: 36px;
  padding: 0 10px;
  border: 1px solid var(--an-border);
  border-radius: var(--an-radius-sm);
  background: var(--an-surface);
  color: var(--an-text);
  font-size: 13px;
  cursor: pointer;
}

.spike-filter-trigger:hover,
.spike-filter-trigger:focus-visible {
  border-color: var(--an-accent);
  outline: none;
}

.spike-filter-trigger-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.spike-filter-popover {
  position: absolute;
  top: 100%;
  right: 0;
  z-index: 20;
  width: 320px;
  max-width: 90vw;
  max-height: 360px;
  overflow-y: auto;
  margin-top: 4px;
  padding: 8px 12px;
  border: 1px solid var(--an-border);
  border-radius: var(--an-radius-sm);
  background: var(--an-surface);
  box-shadow: var(--an-shadow-md);
}

.spike-filter-group {
  margin: 0 0 8px;
  padding: 0;
  border: 0;
}

.spike-filter-group legend {
  padding: 0;
  margin-bottom: 4px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  color: var(--an-text-faint);
}

.spike-filter-option {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0;
  font-size: 13px;
  color: var(--an-text);
  cursor: pointer;
}

.spike-captions {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 16px;
  margin-bottom: 10px;
}

.spike-captions .analytics-section-caption {
  white-space: normal;
}

.spike-visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}

.analytics-filter-chip-text {
  max-width: 280px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Analytics/Analytics.css"],"names":[],"mappings":"AAAA;EACE,yEAAyE;EACzE,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,2BAA2B;EAC3B,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,oBAAoB;EACpB,0BAA0B;EAC1B,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,wBAAwB;EACxB,0BAA0B;EAC1B,kFAAkF;EAClF,kDAAkD;EAClD,wDAAwD;EACxD,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;;EAEnB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,2BAA2B;EAC3B,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,oBAAoB;EACpB,0BAA0B;EAC1B,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,wBAAwB;EACxB,0BAA0B;EAC1B,4CAA4C;EAC5C,8CAA8C;EAC9C,wDAAwD;EACxD,kBAAkB;;EAElB;;;;;;;oEAOkE;EAClE,qEAAqE;EACrE,wEAAwE;EACxE,8EAA8E;EAC9E,oEAAoE;EACpE,sFAAsF;EACtF,qEAAqE;EACrE,wEAAwE;EACxE,8EAA8E;EAC9E,kEAAkE;EAClE,qEAAqE;EACrE,2EAA2E;EAC3E,iEAAiE;EACjE,uFAAuF;EACvF,uEAAuE;EACvE,6EAA6E;EAC7E,6EAA6E;EAC7E,gFAAgF;EAChF,kEAAkE;EAClE,2EAA2E;EAC3E,2EAA2E;EAC3E,oEAAoE;EACpE,qEAAqE;EACrE,2EAA2E;EAC3E,2EAA2E;EAC3E,uEAAuE;EACvE,oEAAoE;EACpE,qEAAqE;EACrE,2EAA2E;EAC3E,iEAAiE;EACjE,sEAAsE;EACtE,uEAAuE;EACvE,6EAA6E;EAC7E,oEAAoE;EACpE,qEAAqE;EACrE,2EAA2E;EAC3E,2EAA2E;EAC3E,uEAAuE;EACvE,qEAAqE;EACrE,2EAA2E;EAC3E,iEAAiE;EACjE,oEAAoE;EACpE,0EAA0E;EAC1E,2EAA2E;EAC3E,sEAAsE;EACtE,qEAAqE;EACrE,2EAA2E;EAC3E,iEAAiE;EACjE,mEAAmE;EACnE,yEAAyE;EACzE,yEAAyE;EACzE,qEAAqE;EACrE,mEAAmE;EACnE,yEAAyE;EACzE,gEAAgE;EAChE,iEAAiE;EACjE,mEAAmE;EACnE,iEAAiE;EACjE,wEAAwE;EACxE,6DAA6D;EAC7D,+EAAo8E;EACp8E,gEAAgE;EAChE,gEAAgE;EAChE,gEAAgE;EAChE,gEAAgE;EAChE,gEAAgE;EAChE,mEAAmE;EACnE,mEAAmE;EACnE,mEAAmE;EACnE,mEAAmE;EACnE,mEAAmE;EACnE,oFAAoF;EACpF,mFAAmF;EACnF,qFAAqF;EACrF,oFAAoF;EACpF,sGAAsG;EACtG,uGAAuG;EACvG,mGAAmG;EACnG,oGAAoG;EACpG,0FAA0F;EAC1F,mGAAmG;EACnG,oGAAoG;EACpG,uFAAuF;EACvF,mFAAmF;EACnF,wFAAwF;EACxF,oFAAoF;EACpF,sGAAsG;EACtG,uGAAuG;EACvG,uGAAuG;EACvG,wGAAwG;EACxG,qFAAqF;EACrF,wFAAwF;EACxF,sFAAsF;EACtF,wFAAwF;EACxF,qFAAqF;EACrF,sFAAsF;EACtF,kGAAkG;EAClG,kGAAkG;EAClG,uEAAuE;EACvE,sEAAsE;;EAEtE;;;;;;;;gEAQ8D;EAC9D,qGAAqG;EACrG,yFAAyF;EACzF,iGAAiG;EACjG,yGAAyG;EACzG,wGAAwG;EACxG,iGAAiG;EACjG,sGAAsG;EACtG,8FAA8F;EAC9F,6GAA6G;EAC7G,8FAA8F;EAC9F,2GAA2G;EAC3G,wGAAwG;EACxG,6HAA6H;EAC7H,8GAA8G;EAC9G,iHAAiH;EACjH,8GAA8G;EAC9G,kHAAkH;EAClH,+GAA+G;EAC/G,yIAAyI;EACzI,2IAA2I;EAC3I,mHAAmH;EACnH,gHAAgH;EAChH,2GAA2G;EAC3G,+FAA+F;AACjG;;AAEA;;EAEE,qGAAqG;AACvG;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,yCAAyC;EACzC,cAAc;EACd,6BAA6B;AAC/B;;AAEA;mFACmF;AACnF;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,WAAW;EACX,wBAAwB;EACxB,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,YAAY;EACZ,eAAe;EACf,kCAAkC;EAClC,kCAAkC;EAClC,6BAA6B;EAC7B,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,+BAA+B;AACjC;;AAEA;;EAEE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,4BAA4B;EAC5B,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,uCAAuC;EACvC,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;wEAGwE;AACxE;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,0CAA0C;EAC1C,8DAA8D;EAC9D,gBAAgB;EAChB,uBAAuB;EACvB,wBAAwB;EACxB,kCAAkC;EAClC,gBAAgB;EAChB,oDAAoD;EACpD,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kCAAkC;EAClC,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;8CAC8C;AAC9C;EACE,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;wBAGwB;AACxB;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA,8EAA8E;AAC9E;;EAEE,mCAAmC;AACrC;;AAEA;EACE;;IAEE,2DAA2D;EAC7D;AACF;;AAEA,6EAA6E;AAC7E;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA,iFAAiF;EACjF;IACE,OAAO;IACP,WAAW;IACX,yEAAyE;IACzE,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,SAAO;EACP,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;;AAGA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;AAClB;;;AAGA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kCAAkC;EAClC,kCAAkC;EAClC,6BAA6B;EAC7B,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA,2EAA2E;;AAE3E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kCAAkC;EAClC,kCAAkC;EAClC,6BAA6B;EAC7B,2BAA2B;EAC3B,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,kCAAkC;EAClC,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA,mEAAmE;;AAEnE;EACE,aAAa;EACb,SAAO;EACP,YAAY;EACZ,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EAErB,0EAA0E;AAC5E;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,kCAAkC;EAClC,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA,0EAA0E;;AAE1E;EACE,iDAAiD;EACjD,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,sDAAsD;EACtD,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA,0EAA0E;;AAE1E;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;;yEAGyE;AACzE;EACE,0EAA0E;AAC5E;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,gDAAgD;AAClD;;AAEA,6EAA6E;;AAE7E;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,kCAAkC;EAClC,6BAA6B;EAC7B,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,YAAY;EACZ,kCAAkC;EAClC,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,SAAS;EACT,kCAAkC;EAClC,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,0EAA0E;EAC1E,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kCAAkC;EAClC,kCAAkC;EAClC,6BAA6B;EAC7B,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE;;IAEE,uBAAuB;IACvB,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA,0EAA0E;;AAE1E;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kCAAkC;EAClC,4BAA4B;EAC5B,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iCAAiC;EACjC,kCAAkC;EAClC,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA,0EAA0E;;AAE1E;EACE,gCAAgC;EAChC,mCAAmC;EACnC,6BAA6B;EAC7B,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA,2EAA2E;;AAE3E;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,4CAA4C;EAC5C,kCAAkC;EAClC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,+BAA+B;EAC/B,uDAAuD;AACzD;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA,kBAAkB,iCAAiC,EAAE;AACrD,qBAAqB,oCAAoC,EAAE;AAC3D,qBAAqB,oCAAoC,EAAE;AAC3D,sBAAsB,qCAAqC,EAAE;;AAE7D;;+CAE+C;AAC/C;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA,2EAA2E;;AAE3E;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,kCAAkC;EAClC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,+BAA+B;EAC/B,gFAAgF;AAClF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,sDAAsD;EACtD,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,cAAc;EACd,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2EAA2E;;AAE3E;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,0EAA0E;;AAE1E;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,kCAAkC;EAClC,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;4EAE4E;AAC5E;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,0EAA0E;;AAE1E;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kCAAkC;EAClC,kCAAkC;EAClC,6BAA6B;EAC7B,qBAAqB;EACrB,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,kCAAkC;EAClC,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,UAAU;EACV,SAAS;AACX;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB","sourcesContent":[".analytics-wrapper {\n  /* ── Light theme tokens (default) ──────────────────────────────────── */\n  --an-bg: #f6f7f9;\n  --an-surface: #ffffff;\n  --an-surface-alt: #f3f4f6;\n  --an-surface-hover: #edf1f5;\n  --an-border: #e5e4df;\n  --an-border-soft: #edece7;\n  --an-text: #0b0b0c;\n  --an-text-muted: #55534e;\n  --an-text-faint: #8a8880;\n  --an-accent: #2a78d6;\n  --an-accent-hover: #1c5cab;\n  --an-accent-soft: #e8f4fc;\n  --an-accent-contrast: #ffffff;\n  --an-good: #0ca30c;\n  --an-warning: #fab219;\n  --an-serious: #ec835a;\n  --an-critical: #d03b3b;\n  --an-warning-bg: #fff8e6;\n  --an-warning-text: #6b4d00;\n  --an-shadow-sm: 0 1px 2px rgba(16, 24, 40, 0.05), 0 1px 1px rgba(16, 24, 40, 0.03);\n  --an-shadow-md: 0 10px 28px rgba(16, 24, 40, 0.09);\n  --an-shadow-accent: 0 10px 26px rgba(42, 120, 214, 0.16);\n  --an-radius-lg: 16px;\n  --an-radius: 10px;\n  --an-radius-sm: 8px;\n\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  background: var(--an-bg);\n  color-scheme: light;\n}\n\n.analytics-wrapper[data-theme=\"dark\"] {\n  --an-bg: #0e1013;\n  --an-surface: #17191e;\n  --an-surface-alt: #1d2027;\n  --an-surface-hover: #262a32;\n  --an-border: #2b2e36;\n  --an-border-soft: #22252c;\n  --an-text: #f1f2f4;\n  --an-text-muted: #b7bac1;\n  --an-text-faint: #80838d;\n  --an-accent: #5b9ce6;\n  --an-accent-hover: #7db1ec;\n  --an-accent-soft: #1c3350;\n  --an-accent-contrast: #08131f;\n  --an-good: #35d45b;\n  --an-warning: #ffcc4d;\n  --an-serious: #ff9a6b;\n  --an-critical: #ff6161;\n  --an-warning-bg: #362a0c;\n  --an-warning-text: #ffdf9e;\n  --an-shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.4);\n  --an-shadow-md: 0 12px 30px rgba(0, 0, 0, 0.5);\n  --an-shadow-accent: 0 12px 28px rgba(91, 156, 230, 0.22);\n  color-scheme: dark;\n\n  /* ── MDS component tokens ──────────────────────────────────────────\n     McTopBar/McTable/McSelect/etc. are shadow-DOM web components whose\n     internal styles read these --mds_brand_appearance_* vars (aliased\n     inside each component's own :host block into --mds_foundations_*).\n     Custom properties inherit through shadow boundaries, so overriding\n     them here re-themes the MDS components too — app-wide default is\n     the light bundle imported in index.js, this is the dark diff of\n     @maersk-global/mds-design-tokens maersk/light vs maersk/dark. */\n  --mds_brand_appearance_neutral_default_text-color: rgb(240, 240, 240);\n  --mds_brand_appearance_neutral_default_background-color: rgb(20, 20, 20);\n  --mds_brand_appearance_neutral_default_on-background-color: rgb(240, 240, 240);\n  --mds_brand_appearance_neutral_default_border-color: rgb(76, 76, 76);\n  --mds_brand_appearance_neutral_default_opacity_border-color: rgba(255, 255, 255, 0.24);\n  --mds_brand_appearance_neutral_weakest_text-color: rgb(138, 138, 138);\n  --mds_brand_appearance_neutral_weakest_background-color: rgb(33, 33, 33);\n  --mds_brand_appearance_neutral_weakest_on-background-color: rgb(240, 240, 240);\n  --mds_brand_appearance_neutral_weak_text-color: rgb(212, 212, 212);\n  --mds_brand_appearance_neutral_weak_background-color: rgb(54, 54, 54);\n  --mds_brand_appearance_neutral_weak_on-background-color: rgb(240, 240, 240);\n  --mds_brand_appearance_neutral_weak_border-color: rgb(54, 54, 54);\n  --mds_brand_appearance_neutral_weak_opacity_background-color: rgba(255, 255, 255, 0.14);\n  --mds_brand_appearance_neutral_strong_background-color: rgb(76, 76, 76);\n  --mds_brand_appearance_neutral_strong_on-background-color: rgb(240, 240, 240);\n  --mds_brand_appearance_neutral_strongest_background-color: rgb(106, 106, 106);\n  --mds_brand_appearance_neutral_strongest_on-background-color: rgb(240, 240, 240);\n  --mds_brand_appearance_neutral_inverse_text-color: rgb(20, 20, 20);\n  --mds_brand_appearance_neutral_inverse_background-color: rgb(255, 255, 255);\n  --mds_brand_appearance_neutral_inverse_on-background-color: rgb(20, 20, 20);\n  --mds_brand_appearance_neutral_inverse_border-color: rgb(20, 20, 20);\n  --mds_brand_appearance_primary_default_text-color: rgb(240, 240, 240);\n  --mds_brand_appearance_primary_default_background-color: rgb(255, 255, 255);\n  --mds_brand_appearance_primary_default_on-background-color: rgb(20, 20, 20);\n  --mds_brand_appearance_primary_default_border-color: rgb(255, 255, 255);\n  --mds_brand_appearance_primary_default_link-color: rgb(66, 176, 213);\n  --mds_brand_appearance_primary_weak_background-color: rgb(54, 54, 54);\n  --mds_brand_appearance_primary_weak_on-background-color: rgb(240, 240, 240);\n  --mds_brand_appearance_primary_weak_border-color: rgb(54, 54, 54);\n  --mds_brand_appearance_secondary_default_text-color: rgb(66, 176, 213);\n  --mds_brand_appearance_secondary_weak_background-color: rgb(12, 36, 44);\n  --mds_brand_appearance_secondary_weak_on-background-color: rgb(158, 215, 234);\n  --mds_brand_appearance_secondary_weak_border-color: rgba(23, 69, 84);\n  --mds_brand_appearance_success_default_text-color: rgb(127, 209, 117);\n  --mds_brand_appearance_success_default_background-color: rgb(127, 209, 117);\n  --mds_brand_appearance_success_default_on-background-color: rgb(20, 20, 20);\n  --mds_brand_appearance_success_default_border-color: rgb(127, 209, 117);\n  --mds_brand_appearance_success_weak_background-color: rgb(18, 51, 17);\n  --mds_brand_appearance_success_weak_on-background-color: rgb(216, 242, 213);\n  --mds_brand_appearance_success_weak_border-color: rgb(27, 70, 23);\n  --mds_brand_appearance_warning_default_text-color: rgb(242, 205, 89);\n  --mds_brand_appearance_warning_default_background-color: rgb(242, 205, 89);\n  --mds_brand_appearance_warning_default_on-background-color: rgb(20, 20, 20);\n  --mds_brand_appearance_warning_default_border-color: rgb(242, 205, 89);\n  --mds_brand_appearance_warning_weak_background-color: rgb(63, 51, 16);\n  --mds_brand_appearance_warning_weak_on-background-color: rgb(253, 237, 186);\n  --mds_brand_appearance_warning_weak_border-color: rgb(83, 68, 19);\n  --mds_brand_appearance_error_default_text-color: rgb(255, 162, 166);\n  --mds_brand_appearance_error_default_background-color: rgb(255, 162, 166);\n  --mds_brand_appearance_error_default_on-background-color: rgb(20, 20, 20);\n  --mds_brand_appearance_error_default_border-color: rgb(255, 162, 166);\n  --mds_brand_appearance_error_weak_background-color: rgb(80, 23, 33);\n  --mds_brand_appearance_error_weak_on-background-color: rgb(247, 229, 230);\n  --mds_brand_appearance_error_weak_border-color: rgb(104, 28, 37);\n  --mds_brand_appearance_info_default_text-color: rgb(22, 134, 189);\n  --mds_brand_appearance_info_default_border-color: rgb(22, 134, 189);\n  --mds_brand_appearance_info_weak_background-color: rgb(0, 36, 61);\n  --mds_brand_appearance_info_weak_on-background-color: rgb(195, 228, 243);\n  --mds_brand_appearance_info_weak_border-color: rgb(0, 62, 98);\n  --mds_brand_appearance_static_logo_url: url(\"data:image/svg+xml,<svg width='121' height='26' viewBox='0 0 121 26' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M108.596 18.8277V6.78682H111.422V11.6023L116.802 6.78682H120.628L114.208 12.3797L120.858 18.8277H116.898L111.422 13.3513V18.8277H108.596Z' fill='white'/><path fill-rule='evenodd' clip-rule='evenodd' d='M97.3102 18.8272H96.3668C95.1353 18.8272 94.5424 18.108 94.5424 17.0606V15.4881H97.3102V16.42H103.191V13.9554H96.4455C95.3686 13.9554 94.5928 13.2232 94.5928 12.2082V8.63337C94.5928 7.55177 95.4373 6.78725 96.4638 6.78725H104.176C105.218 6.78725 105.939 7.57303 105.939 8.7101V10.1467H103.191V9.19451H97.3102V11.5666H104.037C105.03 11.5666 105.939 12.2304 105.939 13.508V16.9441C105.939 18.1154 105.297 18.8272 104.094 18.8272H97.3102Z' fill='white'/><path fill-rule='evenodd' clip-rule='evenodd' d='M83.5521 12.3088H89.5295V9.18788H83.5521V12.3088ZM80.7645 18.8211V6.77925H90.2854C91.5572 6.77925 92.2965 7.52343 92.2965 8.79916V12.8436C92.2965 13.7754 91.4813 14.6158 89.8993 14.6158C89.8097 14.6213 89.7191 14.6158 89.6249 14.6158L92.3962 18.8211H89.3376L86.7098 14.7036H83.5524V18.8211H80.7645Z' fill='white'/><path fill-rule='evenodd' clip-rule='evenodd' d='M67.1551 18.8209V6.78005H78.5325V9.1873H69.9027V11.5788H77.3019V13.9288H69.9027V16.4128H78.5535V18.8209H67.1551Z' fill='white'/><path fill-rule='evenodd' clip-rule='evenodd' d='M60.8901 14.159L58.7025 9.05514L56.5652 14.159H60.8901ZM54.6084 18.8209H51.5333L56.8198 6.78005H60.605L65.929 18.8209H62.8933L61.8456 16.422H55.624L54.6084 18.8209Z' fill='white'/><path fill-rule='evenodd' clip-rule='evenodd' d='M36.1834 18.821V6.78015H39.3537L43.3721 15.7778L47.3311 6.78015H50.3687V18.821H47.7538V11.8165L44.7363 18.821H41.9494L38.8935 11.8544V18.821H36.1834Z' fill='white'/><path fill-rule='evenodd' clip-rule='evenodd' d='M24.2667 23.0356C24.2667 24.673 22.9596 26 21.3477 26H2.91987C1.30705 26 0 24.673 0 23.0356V2.9653C0 1.32788 1.30705 0 2.91987 0H21.3477C22.9596 0 24.2667 1.32788 24.2667 2.9653V23.0356Z' fill='%2342B0D5'/><path fill-rule='evenodd' clip-rule='evenodd' d='M15.9403 12.6561L20.653 6.5436L20.6385 6.52421L13.8281 9.91592L12.1455 2.29405H12.1217L10.4399 9.91592L3.62953 6.52421L3.61418 6.5436L8.32778 12.6561L1.51736 16.0487L1.52247 16.0725H9.08127L7.39955 23.6952L7.42086 23.7058L12.1336 17.5933L16.8463 23.7058L16.8677 23.6944L15.1868 16.0725H22.7456L22.7507 16.0487L15.9403 12.6561Z' fill='white'/></svg>\");\n  --mds_brand_appearance_opacity_default_10: rgba(20, 20, 20, 0.1);\n  --mds_brand_appearance_opacity_default_30: rgba(20, 20, 20, 0.3);\n  --mds_brand_appearance_opacity_default_50: rgba(20, 20, 20, 0.5);\n  --mds_brand_appearance_opacity_default_70: rgba(20, 20, 20, 0.7);\n  --mds_brand_appearance_opacity_default_90: rgba(20, 20, 20, 0.9);\n  --mds_brand_appearance_opacity_inverse_10: rgba(255, 255, 255, 0.1);\n  --mds_brand_appearance_opacity_inverse_30: rgba(255, 255, 255, 0.3);\n  --mds_brand_appearance_opacity_inverse_50: rgba(255, 255, 255, 0.5);\n  --mds_brand_appearance_opacity_inverse_70: rgba(255, 255, 255, 0.7);\n  --mds_brand_appearance_opacity_inverse_90: rgba(255, 255, 255, 0.9);\n  --mds_brand_appearance_state_neutral_default_hover_background-color: rgb(54, 54, 54);\n  --mds_brand_appearance_state_neutral_default_hover_border-color: rgb(106, 106, 106);\n  --mds_brand_appearance_state_neutral_default_active_background-color: rgb(76, 76, 76);\n  --mds_brand_appearance_state_neutral_default_active_border-color: rgb(138, 138, 138);\n  --mds_brand_appearance_state_neutral_weakest_opacity_hover_background-color: rgba(255, 255, 255, 0.14);\n  --mds_brand_appearance_state_neutral_weakest_opacity_active_background-color: rgba(255, 255, 255, 0.24);\n  --mds_brand_appearance_state_neutral_weak_opacity_hover_background-color: rgba(255, 255, 255, 0.24);\n  --mds_brand_appearance_state_neutral_weak_opacity_active_background-color: rgba(255, 255, 255, 0.32);\n  --mds_brand_appearance_state_neutral_strongest_active_background-color: rgb(179, 179, 179);\n  --mds_brand_appearance_state_neutral_inverse_opacity_hover_background-color: rgba(20, 20, 20, 0.06);\n  --mds_brand_appearance_state_neutral_inverse_opacity_active_background-color: rgba(20, 20, 20, 0.12);\n  --mds_brand_appearance_state_primary_default_hover_background-color: rgb(226, 226, 226);\n  --mds_brand_appearance_state_primary_default_hover_border-color: rgb(226, 226, 226);\n  --mds_brand_appearance_state_primary_default_active_background-color: rgb(212, 212, 212);\n  --mds_brand_appearance_state_primary_default_active_border-color: rgb(212, 212, 212);\n  --mds_brand_appearance_state_primary_weakest_opacity_hover_background-color: rgba(255, 255, 255, 0.14);\n  --mds_brand_appearance_state_primary_weakest_opacity_active_background-color: rgba(255, 255, 255, 0.24);\n  --mds_brand_appearance_state_secondary_weakest_opacity_hover_background-color: rgba(66, 176, 213, 0.16);\n  --mds_brand_appearance_state_secondary_weakest_opacity_active_background-color: rgba(66, 176, 213, 0.28);\n  --mds_brand_appearance_state_success_default_hover_background-color: rgb(92, 189, 82);\n  --mds_brand_appearance_state_success_default_active_background-color: rgb(155, 223, 146);\n  --mds_brand_appearance_state_warning_default_hover_background-color: rgb(223, 187, 75);\n  --mds_brand_appearance_state_warning_default_active_background-color: rgb(251, 216, 107);\n  --mds_brand_appearance_state_error_default_hover_background-color: rgb(251, 130, 136);\n  --mds_brand_appearance_state_error_default_active_background-color: rgb(253, 187, 190);\n  --mds_brand_appearance_state_error_weakest_opacity_hover_background-color: rgba(139, 39, 48, 0.16);\n  --mds_brand_appearance_state_error_weakest_opacity_active_background-color: rgba(139, 39, 48, 0.4);\n  --mds_brand_appearance_state_focus_default_shadow_color: rgb(0, 62, 98);\n  --mds_brand_appearance_state_focus_vanity_shadow_color: rgb(0, 62, 98);\n\n  /* ── MDS foundation tokens (re-declared, not just referenced) ───────\n     These are var() aliases onto the --mds_brand_appearance_* tokens\n     above, but the global light bundle (index.js) already declares\n     them once at :root — CSS freezes a custom property's resolved\n     value at the scope where it's declared and inherits that frozen\n     value, so redefining --mds_brand_appearance_* deeper in the tree\n     does NOT retroactively re-resolve a --mds_foundations_* alias\n     declared only at :root. Re-declaring the same alias expression\n     here forces it to re-resolve using the dark values above. */\n  --mds_foundations_body_background-color: var(--mds_brand_appearance_neutral_default_background-color);\n  --mds_foundations_body_text-color: var(--mds_brand_appearance_neutral_default_text-color);\n  --mds_foundations_breadcrumb_item_text-color: var(--mds_brand_appearance_neutral_weak_text-color);\n  --mds_foundations_breadcrumb_separator_text-color: var(--mds_brand_appearance_neutral_weakest_text-color);\n  --mds_foundations_horizontal-rule_border-color: var(--mds_brand_appearance_neutral_default_border-color);\n  --mds_foundations_link_default_text-color: var(--mds_brand_appearance_primary_default_link-color);\n  --mds_foundations_modal_background-color: var(--mds_brand_appearance_neutral_default_background-color);\n  --mds_foundations_modal_close_background-color: var(--mds_brand_appearance_opacity_default_50);\n  --mds_foundations_modal_footer_background-color: var(--mds_brand_appearance_neutral_weakest_background-color);\n  --mds_foundations_table_border-color: var(--mds_brand_appearance_neutral_default_border-color);\n  --mds_foundations_table_cell_background-color: var(--mds_brand_appearance_neutral_default_background-color);\n  --mds_foundations_table_cell_text-color: var(--mds_brand_appearance_neutral_default_on-background-color);\n  --mds_foundations_table_cell_hover_background-color: var(--mds_brand_appearance_state_neutral_default_hover_background-color);\n  --mds_foundations_table_cell_hover_text-color: var(--mds_brand_appearance_neutral_default_on-background-color);\n  --mds_foundations_table_cell_selected_background-color: var(--mds_brand_appearance_primary_weak_background-color);\n  --mds_foundations_table_cell_selected_text-color: var(--mds_brand_appearance_primary_weak_on-background-color);\n  --mds_foundations_table_header-cell_background-color: var(--mds_brand_appearance_neutral_weakest_background-color);\n  --mds_foundations_table_header-cell_text-color: var(--mds_brand_appearance_neutral_weakest_on-background-color);\n  --mds_foundations_table_header-cell_sort_hover_background-color: var(--mds_brand_appearance_state_neutral_default_hover_background-color);\n  --mds_foundations_table_header-cell_sort_active_background-color: var(--mds_brand_appearance_state_neutral_default_active_background-color);\n  --mds_foundations_table_zebra-stripe_background-color: var(--mds_brand_appearance_neutral_weakest_background-color);\n  --mds_foundations_table_zebra-stripe_text-color: var(--mds_brand_appearance_neutral_weakest_on-background-color);\n  --mds_foundations_table_caption_text-color: var(--mds_brand_appearance_neutral_default_on-background-color);\n  --mds_foundations_table_subtext_text-color: var(--mds_brand_appearance_neutral_weak_text-color);\n}\n\n.analytics-wrapper,\n.analytics-wrapper * {\n  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.analytics-topbar {\n  padding-left: 20px;\n  padding-right: 20px;\n  height: 64px;\n  margin-top: -5px;\n  border-bottom: 1px solid var(--an-border);\n  flex-shrink: 0;\n  background: var(--an-surface);\n}\n\n/* Top bar + toolbar (filters, section nav, refresh) stay pinned while\n   scrolling. --an-toolbar-top / --an-sticky-offset are measured in Analytics.js. */\n.analytics-topbar-wrap {\n  position: sticky;\n  top: 0;\n  z-index: 21;\n  display: flow-root;\n  background: var(--an-surface);\n  flex-shrink: 0;\n}\n\n.analytics-intro {\n  padding: 16px 28px 10px;\n}\n\n.analytics-toolbar {\n  position: sticky;\n  top: var(--an-toolbar-top, 0px);\n  z-index: 20;\n  background: var(--an-bg);\n  border-bottom: 1px solid var(--an-border);\n  flex-shrink: 0;\n}\n\n.analytics-toolbar-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 28px;\n}\n\n.analytics-filters-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  flex-shrink: 0;\n  height: 34px;\n  padding: 0 12px;\n  border: 1px solid var(--an-border);\n  border-radius: var(--an-radius-sm);\n  background: var(--an-surface);\n  color: var(--an-text);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  box-shadow: var(--an-shadow-sm);\n}\n\n.analytics-filters-toggle:hover,\n.analytics-filters-toggle-open {\n  border-color: var(--an-accent);\n  color: var(--an-accent);\n}\n\n.analytics-filters-badge {\n  min-width: 18px;\n  height: 18px;\n  padding: 0 5px;\n  border-radius: 9px;\n  background: var(--an-accent);\n  color: var(--an-accent-contrast);\n  font-size: 11px;\n  line-height: 18px;\n  text-align: center;\n}\n\n.analytics-filters-trend {\n  padding-left: 7px;\n  border-left: 1px solid var(--an-border);\n  color: var(--an-text-muted);\n  font-size: 12px;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n/* Side panel docked to the right edge, under the pinned toolbar. It is narrow so\n   the data stays visible next to it, and scrolls internally if the filters are\n   taller than the window. On wide screens the page reflows beside it (see the\n   .analytics-filters-open rules below), so nothing is covered at all. */\n.analytics-wrapper {\n  --an-filter-panel-w: 420px;\n}\n\n.analytics-filter-panel {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  width: min(var(--an-filter-panel-w), 100%);\n  max-height: calc(100vh - var(--an-sticky-offset, 72px) - 16px);\n  overflow-y: auto;\n  padding: 10px 14px 14px;\n  background: var(--an-bg);\n  border: 1px solid var(--an-border);\n  border-top: none;\n  border-radius: 0 0 var(--an-radius) var(--an-radius);\n  box-shadow: var(--an-shadow-md);\n}\n\n.analytics-filter-panel[hidden] {\n  display: none;\n}\n\n.analytics-filter-panel-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.analytics-filter-panel-title {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--an-text);\n}\n\n.analytics-filter-panel-close {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border: none;\n  border-radius: var(--an-radius-sm);\n  background: transparent;\n  cursor: pointer;\n}\n\n.analytics-filter-panel-close:hover {\n  background: var(--an-surface-hover, var(--an-accent-soft));\n}\n\n/* Narrow-column layout for the shared FilterBar: everything stacks, and the\n   individual filter inputs sit two per row. */\n.analytics-filter-panel .analytics-filter-bar {\n  margin-bottom: 0;\n  padding: 12px;\n  box-shadow: none;\n}\n\n.analytics-filter-panel .analytics-filter-top-row {\n  flex-direction: column;\n  align-items: stretch;\n  gap: 12px;\n}\n\n.analytics-filter-panel .analytics-trend-select {\n  min-width: 0;\n  width: 100%;\n}\n\n.analytics-filter-panel .analytics-filter-row {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  align-items: start;\n  gap: 12px;\n  margin-top: 14px;\n}\n\n.analytics-filter-panel .analytics-filter-field {\n  min-width: 0;\n}\n\n.analytics-filter-panel .analytics-filter-field-hint {\n  max-width: none;\n}\n\n.analytics-filter-panel .analytics-apply-btn {\n  grid-column: 1 / -1;\n  width: 100%;\n}\n\n.analytics-filter-panel .analytics-filter-chips {\n  margin-top: 12px;\n}\n\n/* The panel scrolls (overflow), which would crop FilterSelector's absolutely\n   positioned list. Inside the panel it flows in the layout instead, so the\n   panel grows to show it. Stays `relative` to keep its z-index above the\n   click-away overlay. */\n.analytics-filter-panel .fsel-dropdown-wrapper {\n  width: 100%;\n}\n\n.analytics-filter-panel .fsel-dropdown {\n  position: relative;\n  top: auto;\n  left: auto;\n  min-width: 0;\n  max-height: none;\n  margin-top: 8px;\n  box-shadow: none;\n}\n\n/* Wide screens: make room for the panel so the dashboard reflows beside it. */\n.analytics-container,\n.analytics-intro {\n  transition: padding-right 0.2s ease;\n}\n\n@media (min-width: 1100px) {\n  .analytics-filters-open .analytics-container,\n  .analytics-filters-open .analytics-intro {\n    padding-right: calc(28px + var(--an-filter-panel-w) + 16px);\n  }\n}\n\n/* Compact screens (phones / short windows): only the toolbar stays pinned. */\n@media (max-width: 720px), (max-height: 640px) {\n  .analytics-topbar-wrap {\n    position: static;\n  }\n}\n\n@media (max-width: 720px) {\n  .analytics-intro {\n    padding: 12px 12px 8px;\n  }\n\n  .analytics-main-header {\n    font-size: 18px;\n  }\n\n  .analytics-toolbar-row {\n    padding: 6px 12px;\n    gap: 8px;\n  }\n\n  .analytics-refresh-label {\n    display: none;\n  }\n\n  .analytics-refresh-btn {\n    padding: 0 10px;\n  }\n\n  /* Phones: full-width sheet, capped so part of the data stays visible below it. */\n  .analytics-filter-panel {\n    left: 0;\n    width: auto;\n    max-height: min(60vh, calc(100vh - var(--an-sticky-offset, 72px) - 12px));\n    padding: 8px 10px 12px;\n    border-left: none;\n    border-right: none;\n    border-radius: 0;\n  }\n\n  .analytics-filter-panel .analytics-filter-row {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n\n@media (max-width: 520px) {\n  .analytics-filters-trend {\n    display: none;\n  }\n}\n\n.analytics-container {\n  flex: 1;\n  background-color: var(--an-bg);\n  padding: 4px 28px 40px;\n}\n\n@media (max-width: 720px) {\n  .analytics-container {\n    padding: 4px 12px 32px;\n  }\n}\n\n\n.analytics-main-header {\n  font-size: 21px;\n  font-weight: 700;\n  letter-spacing: -0.015em;\n  color: var(--an-text);\n  margin: 0;\n}\n\n.analytics-subheader {\n  margin: 5px 0 0;\n  font-size: 13px;\n  line-height: 1.45;\n  color: var(--an-text-muted);\n  max-width: 640px;\n}\n\n\n.analytics-refresh-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 14px;\n  border: 1px solid var(--an-border);\n  border-radius: var(--an-radius-sm);\n  background: var(--an-surface);\n  color: var(--an-text);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  box-shadow: var(--an-shadow-sm);\n}\n\n.analytics-refresh-btn:hover {\n  border-color: var(--an-accent);\n  color: var(--an-accent);\n}\n\n/* ── Theme toggle ────────────────────────────────────────────────────── */\n\n.theme-toggle-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 12px;\n  border: 1px solid var(--an-border);\n  border-radius: var(--an-radius-sm);\n  background: var(--an-surface);\n  color: var(--an-text-muted);\n  cursor: pointer;\n  box-shadow: var(--an-shadow-sm);\n}\n\n.theme-toggle-btn:hover {\n  border-color: var(--an-accent);\n  color: var(--an-accent);\n}\n\n.analytics-back-btn {\n  background: none;\n  border: 1px solid var(--an-border);\n  border-radius: var(--an-radius-sm);\n  padding: 6px 14px;\n  font-size: 13px;\n  color: var(--an-text);\n  cursor: pointer;\n}\n\n.analytics-back-btn:hover {\n  border-color: var(--an-accent);\n  color: var(--an-accent);\n}\n\n/* ── Section nav ─────────────────────────────────────────────── */\n\n.section-nav {\n  display: flex;\n  flex: 1;\n  min-width: 0;\n  gap: 8px;\n  flex-wrap: nowrap;\n  overflow-x: auto;\n  padding: 2px 16px 2px 0;\n  scrollbar-width: none;\n  -webkit-mask-image: linear-gradient(to right, #000 calc(100% - 20px), transparent);\n  mask-image: linear-gradient(to right, #000 calc(100% - 20px), transparent);\n}\n\n.section-nav::-webkit-scrollbar {\n  display: none;\n}\n\n.section-nav-link {\n  flex-shrink: 0;\n  padding: 6px 14px;\n  border-radius: 16px;\n  background: var(--an-surface);\n  border: 1px solid var(--an-border);\n  color: var(--an-text-muted);\n  font-size: 12.5px;\n  font-weight: 600;\n  text-decoration: none;\n  white-space: nowrap;\n  transition: all 0.15s ease;\n}\n\n.section-nav-link:hover {\n  border-color: var(--an-accent);\n  color: var(--an-accent);\n}\n\n.section-nav-link-active {\n  background: var(--an-accent);\n  border-color: var(--an-accent);\n  color: var(--an-accent-contrast);\n}\n\n/* ── Dashboard sections ─────────────────────────────────────────────── */\n\n.analytics-section {\n  scroll-margin-top: var(--an-sticky-offset, 260px);\n  padding-top: 20px;\n}\n\n.analytics-section-header {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 10px;\n}\n\n.analytics-section-heading {\n  font-family: \"Maersk Headline\", MaerskText, sans-serif;\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--an-text);\n  margin: 0;\n}\n\n.analytics-section-caption {\n  font-size: 12px;\n  color: var(--an-text-faint);\n  white-space: nowrap;\n}\n\n/* ── Collapsible tables ─────────────────────────────────────────────── */\n\n.analytics-collapsible summary {\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--an-accent);\n  padding: 4px 0 12px;\n  list-style: none;\n}\n\n.analytics-collapsible summary::-webkit-details-marker {\n  display: none;\n}\n\n.analytics-collapsible summary::before {\n  content: \"▸ \";\n}\n\n.analytics-collapsible[open] summary::before {\n  content: \"▾ \";\n}\n\n/* Breakdown tables: scroll inside the card (both ways) with an always-visible\n   scrollbar, instead of cropping wide columns or growing 40+ rows tall.\n   scrollbar-color inherits, so it also reaches the scroller inside the MDS\n   table's shadow DOM and stops macOS from hiding it as an overlay bar. */\n.analytics-collapsible {\n  scrollbar-color: var(--an-text-faint) var(--an-surface-hover, transparent);\n}\n\n.analytics-collapsible mc-table {\n  display: block;\n  max-width: 100%;\n  max-height: 480px;\n  overflow: auto;\n  scrollbar-width: thin;\n}\n\n.analytics-collapsible mc-table::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n}\n\n.analytics-collapsible mc-table::-webkit-scrollbar-thumb {\n  background: var(--an-text-faint);\n  border-radius: 5px;\n}\n\n.analytics-collapsible mc-table::-webkit-scrollbar-track {\n  background: var(--an-surface-hover, transparent);\n}\n\n/* ── Timeliness tabs (Approval / PO / Invoice share one detail panel) ──── */\n\n.tl-tab-strip {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  margin-top: 18px;\n  padding-top: 14px;\n  border-top: 1px solid var(--an-border-soft);\n}\n\n.tl-tab {\n  padding: 8px 16px;\n  border-radius: var(--an-radius-sm);\n  border: 1px solid var(--an-border);\n  background: var(--an-surface);\n  color: var(--an-text-muted);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.tl-tab:hover {\n  border-color: var(--an-accent);\n  color: var(--an-accent);\n}\n\n.tl-tab-active {\n  background: var(--an-accent);\n  border-color: var(--an-accent);\n  color: var(--an-accent-contrast);\n}\n\n.tl-detail-header {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 14px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid var(--an-border-soft);\n}\n\n.tl-detail-title {\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--an-text);\n  margin: 0;\n}\n\n.cx-timeliness-card {\n  padding-top: 12px;\n}\n\n.cx-sla-tabs {\n  margin-top: 0;\n  padding-top: 0;\n  border-top: 0;\n  margin-bottom: 18px;\n}\n\n.cx-sla-rule-row,\n.cx-sla-table-heading {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.cx-sla-rule-row {\n  margin-bottom: 16px;\n}\n\n.cx-sla-rule-row .analytics-section-caption {\n  white-space: normal;\n  text-align: right;\n}\n\n.cx-sla-scope-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 18px;\n}\n\n.cx-sla-scope-label {\n  color: var(--an-text-muted);\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.cx-sla-scope-control {\n  display: inline-flex;\n  gap: 3px;\n  padding: 3px;\n  border: 1px solid var(--an-border);\n  border-radius: var(--an-radius-sm);\n  background: var(--an-surface-alt);\n}\n\n.cx-sla-scope-button {\n  min-height: 32px;\n  padding: 0 12px;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  background: transparent;\n  color: var(--an-text-muted);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.cx-sla-scope-button:hover {\n  color: var(--an-accent);\n}\n\n.cx-sla-scope-button-active {\n  border-color: var(--an-border);\n  background: var(--an-surface);\n  color: var(--an-accent);\n  box-shadow: var(--an-shadow-sm);\n}\n\n.cx-sla-stat-row {\n  margin-top: 14px;\n  margin-bottom: 8px;\n}\n\n.cx-sla-kpi-button {\n  min-width: 0;\n  padding: 0;\n  border: 0;\n  border-radius: var(--an-radius-lg);\n  background: transparent;\n  color: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n\n.cx-sla-kpi-button .stat-tile {\n  height: 100%;\n}\n\n.cx-sla-kpi-button:hover .stat-tile {\n  box-shadow: var(--an-shadow-md);\n  transform: translateY(-1px);\n}\n\n.cx-sla-kpi-button-active .stat-tile {\n  outline: 2px solid var(--an-accent);\n  outline-offset: 2px;\n}\n\n.cx-sla-kpi-button:focus-visible {\n  outline: 2px solid var(--an-accent);\n  outline-offset: 3px;\n}\n\n.cx-sla-stat-row .stat-tile-label {\n  min-height: 0;\n}\n\n.cx-sla-stat-row .stat-tile-subvalue {\n  line-height: 1.5;\n}\n\n.cx-sla-rate-note,\n.cx-sla-empty {\n  margin: 8px 0 18px;\n  color: var(--an-text-faint);\n  font-size: 12px;\n}\n\n.cx-sla-table-wrap {\n  margin-top: 20px;\n  padding-top: 18px;\n  border-top: 1px solid var(--an-border-soft);\n}\n\n.cx-sla-table-heading .analytics-section-title {\n  margin-bottom: 10px;\n}\n\n.cx-sla-table-scroll {\n  max-width: 100%;\n  max-height: 480px;\n  overflow: auto;\n  scrollbar-color: var(--an-text-faint) var(--an-surface-hover, transparent);\n  scrollbar-width: thin;\n}\n\n.cx-sla-table-scroll mc-table {\n  display: block;\n  max-width: 100%;\n  max-height: 480px;\n  overflow: auto;\n  scrollbar-width: thin;\n}\n\n.cx-sla-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 12px;\n}\n\n.cx-sla-page-button {\n  min-height: 34px;\n  padding: 0 14px;\n  border: 1px solid var(--an-border);\n  border-radius: var(--an-radius-sm);\n  background: var(--an-surface);\n  color: var(--an-accent);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.cx-sla-page-button:disabled {\n  cursor: not-allowed;\n  opacity: 0.65;\n}\n\n.cx-sla-page-indicator {\n  color: var(--an-text-muted);\n  font-size: 12px;\n  font-variant-numeric: tabular-nums;\n}\n\n@media (max-width: 640px) {\n  .cx-sla-rule-row,\n  .cx-sla-table-heading {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 6px;\n  }\n\n  .cx-sla-rule-row .analytics-section-caption {\n    text-align: left;\n  }\n\n  .cx-sla-tabs .tl-tab {\n    flex: 1 1 100%;\n  }\n\n  .cx-sla-stat-row {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n\n/* ── Filter bar ─────────────────────────────────────────────────────── */\n\n.analytics-filter-bar {\n  background: var(--an-surface);\n  border: 1px solid var(--an-border);\n  border-radius: var(--an-radius);\n  padding: 16px 18px;\n  margin-bottom: 20px;\n  box-shadow: var(--an-shadow-sm);\n}\n\n.analytics-filter-row {\n  display: flex;\n  align-items: flex-end;\n  gap: 14px;\n  flex-wrap: wrap;\n}\n\n.analytics-filter-field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.analytics-filter-field-hint {\n  font-size: 11px;\n  color: var(--an-text-muted);\n  max-width: 260px;\n  line-height: 1.3;\n}\n\n.analytics-filter-top-row {\n  display: flex;\n  align-items: flex-end;\n  gap: 24px;\n  flex-wrap: wrap;\n}\n\n.analytics-filter-top-row .fsel-row {\n  margin-bottom: 0;\n}\n\n.analytics-trend-select {\n  min-width: 160px;\n}\n\n.analytics-apply-btn {\n  height: 40px;\n  padding: 0 18px;\n  border: none;\n  border-radius: var(--an-radius-sm);\n  background: var(--an-accent);\n  color: var(--an-accent-contrast);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.analytics-apply-btn:hover {\n  background: var(--an-accent-hover);\n}\n\n.analytics-filter-chips {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  margin-top: 14px;\n}\n\n.analytics-filter-chips-label {\n  font-size: 12.5px;\n  color: var(--an-text-muted);\n}\n\n.analytics-filter-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  background: var(--an-accent-soft);\n  border: 1px solid var(--an-accent);\n  border-radius: 16px;\n  font-size: 12.5px;\n  color: var(--an-accent);\n}\n\n.analytics-filter-chip-remove {\n  cursor: pointer;\n}\n\n/* ── Warning banner ─────────────────────────────────────────────────── */\n\n.analytics-warning-banner {\n  background: var(--an-warning-bg);\n  border: 1px solid var(--an-warning);\n  color: var(--an-warning-text);\n  border-radius: var(--an-radius-sm);\n  padding: 10px 16px;\n  font-size: 13px;\n  margin-bottom: 18px;\n}\n\n/* ── Stat tiles ──────────────────────────────────────────────────────── */\n\n.stat-tile-row {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));\n  gap: 14px;\n  margin-bottom: 22px;\n}\n\n.stat-tile {\n  background: var(--an-surface);\n  border: 1px solid var(--an-border);\n  border-left: 3px solid var(--an-accent-soft);\n  border-radius: var(--an-radius-lg);\n  padding: 16px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  box-shadow: var(--an-shadow-sm);\n  transition: box-shadow 0.15s ease, transform 0.15s ease;\n}\n\n.stat-tile:hover {\n  box-shadow: var(--an-shadow-md);\n  transform: translateY(-1px);\n}\n\n.stat-tile-label {\n  font-size: 11.5px;\n  font-weight: 600;\n  color: var(--an-text-faint);\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  line-height: 1.3;\n  min-height: 2.6em;\n  display: flex;\n  align-items: flex-start;\n}\n\n.stat-tile-value {\n  font-size: 28px;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: var(--an-text);\n}\n\n.stat-tile-subvalue {\n  font-size: 12px;\n  color: var(--an-text-faint);\n}\n\n.stat-tile-good { border-left-color: var(--an-good); }\n.stat-tile-warning { border-left-color: var(--an-warning); }\n.stat-tile-serious { border-left-color: var(--an-serious); }\n.stat-tile-critical { border-left-color: var(--an-critical); }\n\n/* Below ~2 columns' worth of the 190px basis, auto-fit would drop to a\n   single column and stack every tile vertically — force 2-up instead so\n   the row stays compact on narrow viewports. */\n@media (max-width: 640px) {\n  .stat-tile-row {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 10px;\n  }\n\n  .stat-tile {\n    padding: 12px 14px;\n    gap: 4px;\n  }\n\n  .stat-tile-value {\n    font-size: 22px;\n  }\n}\n\n@media (max-width: 380px) {\n  .stat-tile-value {\n    font-size: 19px;\n  }\n}\n\n/* ── Overview tab ────────────────────────────────────────────────────── */\n\n.overview-card-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 16px;\n}\n\n.overview-card {\n  background: var(--an-surface);\n  border: 1px solid var(--an-border);\n  border-radius: var(--an-radius-lg);\n  padding: 20px 22px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  box-shadow: var(--an-shadow-sm);\n  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;\n}\n\n.overview-card-clickable {\n  cursor: pointer;\n}\n\n.overview-card-clickable:hover {\n  transform: translateY(-2px);\n  border-color: var(--an-accent);\n  box-shadow: var(--an-shadow-accent);\n}\n\n.overview-card-cx-timeliness {\n  box-sizing: border-box;\n  width: 410px;\n  max-width: 100%;\n}\n\n.overview-card-cx-timeliness .overview-card-metrics {\n  grid-template-columns: minmax(0, 1.4fr) minmax(0, 1fr);\n  column-gap: 28px;\n}\n\n.overview-card-cx-timeliness .overview-card-metric-label {\n  font-size: 10px;\n  letter-spacing: 0.02em;\n  white-space: normal;\n  overflow-wrap: anywhere;\n}\n\n.overview-card-title {\n  font-size: 13px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  color: var(--an-text-muted);\n  margin: 0;\n}\n\n.overview-card-metrics {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(96px, 1fr));\n  gap: 14px 20px;\n  padding-top: 10px;\n  border-top: 1px solid var(--an-border-soft);\n}\n\n.overview-card-metric-label {\n  display: block;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--an-text-faint);\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  margin-bottom: 4px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.overview-card-metric-value {\n  display: block;\n  font-size: 21px;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: var(--an-text);\n}\n\n.overview-card-note {\n  font-size: 11.5px;\n  color: var(--an-text-faint);\n  font-style: italic;\n}\n\n.overview-card-loading,\n.overview-card-error {\n  font-size: 12.5px;\n  color: var(--an-text-faint);\n}\n\n.overview-card-error {\n  color: var(--an-critical);\n}\n\n/* ── Side-by-side metric comparison (Pending Approval vs Pending PO) ─── */\n\n.aging-compare-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 28px;\n  margin-bottom: 28px;\n}\n\n.aging-compare-col {\n  scroll-margin-top: 76px;\n}\n\n.aging-compare-col-header {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 14px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid var(--an-border-soft);\n}\n\n.aging-compare-col-title {\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--an-text);\n  margin: 0;\n}\n\n.aging-compare-subtitle {\n  margin-top: 18px;\n}\n\n@media (max-width: 860px) {\n  .aging-compare-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* ── Dashboard section cards (chart + table) ────────────────────────── */\n\n.analytics-section-card {\n  background: var(--an-surface);\n  border: 1px solid var(--an-border);\n  border-radius: var(--an-radius-lg);\n  padding: 22px 24px;\n  margin-bottom: 20px;\n  box-shadow: var(--an-shadow-sm);\n}\n\n.analytics-section-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--an-text);\n  margin: 0 0 12px;\n}\n\n/* Two side-by-side charts share one row on desktop instead of each\n   claiming a full-width row; collapses to stacked below the width where\n   the funnel's fixed label/value columns would otherwise get too cramped. */\n.analytics-charts-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n  margin-bottom: 20px;\n  align-items: start;\n}\n\n.analytics-charts-row .analytics-section-card {\n  margin-bottom: 0;\n  min-width: 0;\n}\n\n@media (max-width: 1080px) {\n  .analytics-charts-row {\n    grid-template-columns: 1fr;\n  }\n}\n\n.critical-materials-card {\n  border-left: 3px solid var(--an-critical);\n}\n\n/* ── Material Spend & Cost Spike filters ────────────────────────────── */\n\n.spike-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  align-items: flex-end;\n}\n\n.spike-filter {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 200px;\n}\n\n.spike-filter-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--an-text-muted);\n}\n\n.spike-filter-trigger {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  height: 36px;\n  padding: 0 10px;\n  border: 1px solid var(--an-border);\n  border-radius: var(--an-radius-sm);\n  background: var(--an-surface);\n  color: var(--an-text);\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.spike-filter-trigger:hover,\n.spike-filter-trigger:focus-visible {\n  border-color: var(--an-accent);\n  outline: none;\n}\n\n.spike-filter-trigger-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.spike-filter-popover {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  z-index: 20;\n  width: 320px;\n  max-width: 90vw;\n  max-height: 360px;\n  overflow-y: auto;\n  margin-top: 4px;\n  padding: 8px 12px;\n  border: 1px solid var(--an-border);\n  border-radius: var(--an-radius-sm);\n  background: var(--an-surface);\n  box-shadow: var(--an-shadow-md);\n}\n\n.spike-filter-group {\n  margin: 0 0 8px;\n  padding: 0;\n  border: 0;\n}\n\n.spike-filter-group legend {\n  padding: 0;\n  margin-bottom: 4px;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  color: var(--an-text-faint);\n}\n\n.spike-filter-option {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 4px 0;\n  font-size: 13px;\n  color: var(--an-text);\n  cursor: pointer;\n}\n\n.spike-captions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px 16px;\n  margin-bottom: 10px;\n}\n\n.spike-captions .analytics-section-caption {\n  white-space: normal;\n}\n\n.spike-visually-hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n  white-space: nowrap;\n}\n\n.analytics-filter-chip-text {\n  max-width: 280px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
